import { MessageCircleQuestion } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { Spinner } from '@/components/ui'
import { ModuleEmptyPage } from '@/components/layout/ModuleEmptyPage'
import { useCurrentTenant } from '@/features/tenants/useCurrentTenant'

import { DiscoveryPanel } from './components/DiscoveryPanel'
import { KnowledgeDocuments } from './components/KnowledgeDocuments'
import { UploadPanel } from './components/UploadPanel'

/**
 * Pagina de Conhecimento (SS-02): "Ensine seu agente". Importar o site aprende sozinho; o Playground
 * do onboarding segue acessivel enquanto indexa em background. Vocabulario neutro (docs/design/09).
 */
export function KnowledgePage() {
  const { t } = useTranslation()
  const { tenant, isLoading } = useCurrentTenant()

  if (isLoading) {
    return (
      <div className="flex justify-center py-12">
        <Spinner label={t('loading')} />
      </div>
    )
  }

  if (tenant === null) {
    return (
      <ModuleEmptyPage
        icon={MessageCircleQuestion}
        title={t('modules.knowledge.title')}
        description={t('modules.knowledge.description')}
      />
    )
  }

  return (
    <div className="mx-auto flex w-full max-w-4xl flex-col gap-6">
      <header className="flex flex-col gap-1">
        <h1 className="text-xl font-semibold text-foreground-primary">
          {t('knowledge.pageTitle')}
        </h1>
        <p className="text-sm text-foreground-muted">{t('knowledge.pageSubtitle')}</p>
      </header>
      <DiscoveryPanel tenantId={tenant.id} />
      <UploadPanel tenantId={tenant.id} />
      <KnowledgeDocuments tenantId={tenant.id} />
    </div>
  )
}
